/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identity_SubheadlineInputs */

const en_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've noticed that driven people like you tend to share one common struggle...`)
};

const de_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uns ist aufgefallen, dass viele engagierte Menschen wie du dasselbe Problem haben...`)
};

const zh_tw_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們發現，很多像你一樣認真的人，都遇到了一個共同的困擾...`)
};

const zh_cn_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们发现，很多像你一样认真的人，都遇到了一个共同的困扰...`)
};

const es_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos notado que muchas personas dedicadas como tú comparten una misma inquietud...`)
};

const fr_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a remarqué que beaucoup de gens motivés comme toi partagent une même frustration...`)
};

const it_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbiamo notato che tante persone determinate come te hanno un problema in comune...`)
};

const pt_br_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gente percebeu que muita gente dedicada como você tem um desafio em comum...`)
};

const ja_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実は、あなたのように頑張っている人たちが、ある共通の悩みを抱えていることに気づきました...`)
};

const ko_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저희가 보니, 당신처럼 열심히 사는 분들이 공통적으로 겪는 고민이 하나 있더라고요...`)
};

const ru_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы заметили, что многие целеустремлённые люди, как ты, сталкиваются с одной и той же проблемой...`)
};

const th_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราสังเกตว่า คนตั้งใจอย่างคุณหลายคน มักเจอปัญหาเดียวกัน...`)
};

const tr_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senin gibi kendini geliştiren insanların ortak bir sorunu olduğunu fark ettik...`)
};

const ar_identity_subheadline = /** @type {(inputs: Identity_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لاحظنا أن كثيرًا من الأشخاص الجادّين مثلك، يواجهون نفس المشكلة...`)
};

/**
* | output |
* | --- |
* | "We've noticed that driven people like you tend to share one common struggle..." |
*
* @param {Identity_SubheadlineInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const identity_subheadline = /** @type {((inputs?: Identity_SubheadlineInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identity_SubheadlineInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_identity_subheadline(inputs)
	if (locale === "de") return de_identity_subheadline(inputs)
	if (locale === "zh_tw") return zh_tw_identity_subheadline(inputs)
	if (locale === "zh_cn") return zh_cn_identity_subheadline(inputs)
	if (locale === "es") return es_identity_subheadline(inputs)
	if (locale === "fr") return fr_identity_subheadline(inputs)
	if (locale === "it") return it_identity_subheadline(inputs)
	if (locale === "pt_br") return pt_br_identity_subheadline(inputs)
	if (locale === "ja") return ja_identity_subheadline(inputs)
	if (locale === "ko") return ko_identity_subheadline(inputs)
	if (locale === "ru") return ru_identity_subheadline(inputs)
	if (locale === "th") return th_identity_subheadline(inputs)
	if (locale === "tr") return tr_identity_subheadline(inputs)
	return ar_identity_subheadline(inputs)
});